/**
 * MAIN.JSX - Point d'entrée React
 * 
 * Ce fichier initialise l'application React et monte le composant principal
 * dans le DOM. C'est le point d'entrée de l'application POC R3F.
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './styles/main.css'

// Montage de l'application React dans le DOM
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)

